import React from "react";
import { ArrowLeft, MessageCircle } from "lucide-react";
import {
  STRIPE_CONSULTATION_URL,
  buildWhatsAppLink,
  FULL_SUPPORT_WA_MESSAGE,
  DEFAULT_WA_MESSAGE,
} from "../lib/constants";

export default function FinalCTA() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="contact"
      className="py-20 lg:py-28 bg-slate-900 text-white relative overflow-hidden"
      data-testid="final-cta-section"
    >
      <div className="absolute inset-0 opacity-[0.07] divider-dots" />
      <div className="absolute -top-24 -start-24 w-[28rem] h-[28rem] rounded-full bg-emerald-500/5 blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-start">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-emerald-300 px-3 py-1.5 rounded-full text-sm font-medium mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
          خطوة واحدة تفصلك عن قرار واضح
        </div>

        <h2 className="font-tajawal text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
          كلّما اخترت المسار الصحيح أسرع،{" "}
          <span className="text-emerald-400">قلّت الأخطاء المكلفة لاحقاً</span>
        </h2>

        <p className="mt-5 text-base md:text-lg text-slate-300 leading-relaxed max-w-3xl">
          لا تحتاج أن تبدأ بالحيرة. يمكنك أن تبدأ بقرار واضح، ومعرفة ما الذي
          يناسب حالتك تحديداً.
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => scrollTo("#lead-form")}
            className="btn-accent rounded-xl px-6 py-3.5 font-semibold inline-flex items-center gap-2"
            data-testid="final-cta-path"
          >
            تحقّق من مسار إقامتك
            <ArrowLeft className="w-4 h-4" />
          </button>
          <a
            href={STRIPE_CONSULTATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-slate-900 hover:bg-slate-100 rounded-xl px-6 py-3.5 font-semibold transition-colors"
            data-testid="final-cta-consultation"
          >
            احجز استشارة · 100€
          </a>
          <a
            href={buildWhatsAppLink(FULL_SUPPORT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white/30 hover:border-white text-white rounded-xl px-6 py-3.5 font-semibold transition-colors"
            data-testid="final-cta-full"
          >
            اطلب الدعم الكامل · 500€
          </a>
          <a
            href={buildWhatsAppLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-xl px-6 py-3.5 font-semibold transition-colors"
            data-testid="final-cta-whatsapp"
          >
            <MessageCircle className="w-4 h-4" />
            واتساب
          </a>
        </div>
      </div>
    </section>
  );
}
